import isBrowser from './isBrowser'

const checkIsInFirstFold = (element: Element) => {
  if (element && isBrowser()) {
    const viewportHeight = window.innerHeight
    const elementRect = element.getBoundingClientRect()
    const isInFirstFold = elementRect.top >= 0 && elementRect.top < viewportHeight

    return isInFirstFold
  }

  return false
}

export default checkIsInFirstFold
